import * as React from 'react'
import { useSelector, useDispatch } from 'react-redux';
import Snackbar from '@mui/material/Snackbar'
import CloseIcon from '@mui/icons-material/Close';
import { showToast } from '../../redux/common/commonActions';

export default function ToastMsg() {

  const dispatch = useDispatch();
  const vertical = 'top';
  const horizontal = 'right';
  const toastState = useSelector((state) => state.commonState.toastState);

  const handleClose = () => {
    dispatch(showToast({ show: false, msg: "" }))
  }

  return (
    <Snackbar
      anchorOrigin={{ vertical, horizontal }}
      open={toastState.show}
      onClose={handleClose}
      message={toastState.msg}
      severity='info'
      action={<CloseIcon fontSize='small' sx={{ cursor: 'pointer' }} onClick={handleClose} />}
    />
  )
}
